import { FULL_FAQS, GLOBAL_CATALOGS, HAS_DETAILS } from '../types';
import { queryAllContentList, queryContentList } from './cmsAction';

export const onChangeFaqsTabsItem = (value, title) => async (dispatch, getState) => {
  const { faqs: { result: { rowsPerPage } } } = getState();

  await dispatch({
    type: FULL_FAQS.Value,
    payload: value
  });

  if(value && [GLOBAL_CATALOGS.Faqs.Root].includes(value)) {
    await dispatch(searchFaqsList({ contentCode: value, title, rowsPerPage }))
    return;
  }
  await dispatch(queryFaqsList({ contentCode: value, title, rowsPerPage }))
};

export const changeSearchFaqsTitle = (title) => async (dispatch, getState) => {
  await dispatch({
    type: FULL_FAQS.Title,
    payload: title
  });

};

// 關鍵字搜索
export const searchFaqsList = ({ contentCode, title, ruleTag, page = 1, rowsPerPage = 10 }) => async (dispatch, getState) => {
  await dispatch({
    type: FULL_FAQS.Loading,
    payload: true
  });

  const response = await dispatch(queryAllContentList({ contentCode, title, ruleTag, page, rowsPerPage }));
  await dispatch({
    type: FULL_FAQS.List,
    payload: response
  });

  setTimeout(() => {
    dispatch({
      type: FULL_FAQS.Loading,
      payload: false
    });
  }, 260);
};

export const queryFaqsList = ({ contentCode, title, ruleTag, page = 1, rowsPerPage = 10 }) => async (dispatch, getState) => {
  await dispatch({
    type: FULL_FAQS.Loading,
    payload: true
  });
  const response = await dispatch(queryContentList({ contentCode, hasDetails: HAS_DETAILS.True, ruleTag, title, page, rowsPerPage }));
  await dispatch({
    type: FULL_FAQS.List,
    payload: response
  });

  setTimeout(() => {
    dispatch({
      type: FULL_FAQS.Loading,
      payload: false
    });
  }, 260);
};

export const queryFaqsMenus = (list = []) => (dispatch, getState) => {
  dispatch({
    type: GLOBAL_CATALOGS.Faqs.Root,
    payload: list
  });
};


